import * as yup from 'yup';

import { testMaxQuantity } from 'coreOld/yup';

export const costFormSchema = yup.object({
  startDate: yup.string().nullable(),
  endDate: yup.string().nullable(),
  uom: yup.string().nullable(),
  costItems: yup.array().of(
    yup.object({
      minQuantity: yup.string().nullable(),
      maxQuantity: yup
        .string()
        .nullable()
        .test(...testMaxQuantity()),
      cost: yup.string().nullable(),
    })
  ),
});
